<div class="bd-overlay" *ngIf="sequence._0xI8 | async">
  <div class="bd-modal card shadow-lg" [class.shift-left]="isConsoleOpen">

    <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Debug / Admin Panel</h5>
      <button class="btn btn-sm btn-light" (click)="close()">✕</button>
    </div>

    <!-- Tabs Navigation -->
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item" role="presentation" (click)="isConsoleOpen=false">
        <button class="nav-link active" id="app-info-tab" data-bs-toggle="tab" data-bs-target="#app-info" type="button"
          role="tab">App Info</button>
      </li>
      <li class="nav-item" role="presentation" (click)="openConsole()">
        <button class="nav-link" id="api-tester-tab" data-bs-toggle="tab" data-bs-target="#api-tester" type="button"
          role="tab">API Tester</button>
      </li>
    </ul>

    <!-- Tabs Content -->
    <div class="tab-content modal-body-scroll p-3">

      <!-- Tab 1: App Info -->
      <div class="tab-pane fade show active" id="app-info" role="tabpanel">

        <!-- Application Info -->
        <div class="mb-3">
          <h6>Application Info</h6>
          <ul class="list-group">
            <li class="list-group-item">URL: {{ currentUrl }}</li>
            <li class="list-group-item">User Agent: {{ userAgent }}</li>
            <li class="list-group-item">Online: {{ isOnline }}</li>
            <li class="list-group-item">LocalStorage Keys: {{ localStorageCount }}</li>
            <li class="list-group-item">SessionStorage Keys: {{ sessionStorageCount }}</li>
          </ul>
        </div>

        <!-- Actions -->
        <div class="d-grid gap-2">
          <button class="btn btn-danger" (click)="clearCache()">🧹 Clear Cache</button>
          <button class="btn btn-warning" (click)="hardReload()">🔄 Hard Reload</button>
          <button class="btn btn-info" (click)="showStorage()">📦 Show Storage Data</button>
        </div>

        <!-- Scrollable Log Area -->
        <div *ngIf="logData" class="debug-log border rounded p-2 bg-light position-relative mt-3">
          <button class="btn btn-sm btn-light position-absolute top-0 end-0 m-1" (click)="logData=null">✕</button>
          <pre class="mb-0 text-start">{{ logData }}</pre>
        </div>

      </div>

      <div class="tab-pane fade" id="api-tester" role="tabpanel">
        <div class="row g-2 mb-3">
          <div class="col-md-12 text-start">
            <label class="form-label">Access Key</label>
            <input type="password" class="form-control" [(ngModel)]="apiKey">
          </div>

          <div class="col-md-4">
            <label class="form-label">Action</label>
            <select class="form-select" [(ngModel)]="apiMethod">
              <option *ngFor="let m of methods" [value]="m">{{ m }}</option>
            </select>
          </div>

          <div class="col-md-8">
            <label class="form-label">Collection</label>
            <select class="form-select" [(ngModel)]="collectionName">
              <option *ngFor="let c of collections" [value]="c">{{ c }}</option>
            </select>
          </div>

          <div class="col-md-12 text-start">
            <label class="form-label">Filter (JSON)</label>
            <input type="text" class="form-control" placeholder='e.g. { "status": "active" }' [(ngModel)]="filterQuery">
          </div>

          <div class="col-md-12 text-start">
            <label class="form-label">Data (JSON)</label>
            <input type="text" class="form-control" placeholder='e.g. { "name": "John" }' [(ngModel)]="updateData">
          </div>

          <div class="col-md-4">
            <label class="form-label">Limit</label>
            <input type="number" class="form-control" [(ngModel)]="limit" placeholder="10">
          </div>

          <div class="col-md-4">
            <label class="form-label">Sort By</label>
            <input type="text" class="form-control" placeholder="field name" [(ngModel)]="sortBy">
          </div>

          <div class="col-md-4 d-flex align-items-end">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="sortDescending" id="sortDesc">
              <label class="form-check-label" for="sortDesc">Sort Descending</label>
            </div>
          </div>

        </div>

        <div class="d-flex justify-content-center align-items-center gap-2 mb-3">
          <button class="btn btn-info" (click)="getfig()">⚙️ Get Configurations</button>
          <button class="btn btn-primary" (click)="sendApiRequest()">🚀 Send Request</button>
        </div>
      </div>

    </div>
  </div>

  <div class="console-modal card shadow-lg" *ngIf="isConsoleOpen">
    <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
      <h6 class="mb-0">Console / Terminal</h6>
      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-light" (click)="ClearlogToConsole()">🗑️</button>
        <button class="btn btn-sm btn-light" (click)="closeConsole()">✕</button>
      </div>
    </div>
    <div class="card-body console-body p-2 text-start">
      <pre>{{ consoleLogs }}</pre>
    </div>
  </div>
</div>